// extracted by mini-css-extract-plugin
module.exports = {"button":"_fe37bc3"};